import { emptyAddress } from './address';
import { emptyUser } from './user';

export type FlexCodeListResponse = Components.Responses.FlexCodeListResponse;

export type FlexCodeResponse = Components.Responses.FlexCodeResponse;

export type FlexCodeGen4 = Components.Schemas.FlexCodeGen4;
export type FlexCode = Components.Schemas.FlexCode;
export type FlexCodeReason = Components.Schemas.FlexCodeReason;

export const emptyFlexCodeGen4 = (): FlexCodeGen4 => ({
	id: '',
	deviceId: '',
	flexCode: '',
	reason: '',
	creatorId: '',
	creatorCompanyId: '',
	utcCreateDate: '',
	utcStartTime: '',
	utcEndTime: '',
	firstName: '',
	lastName: '',
	email: '',
	mobilePhoneNumber: '',
	propertyName: '',
	deviceLocation: '',
	address: emptyAddress(),
	timezone: '',
});
